import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CreateCollection() {
    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div class="no-bottom no-top" id="content">

                <section id="subheader" class="text-dark">

                </section>


                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div class="container">
                        <div class="row wow fadeIn">
                            <div class="col-lg-3 col-sm-6 col-xs-12">


                                <h5>Preview</h5>
                                <div class="nft__item">
                                    <div class="author_list_pp">
                                    </div>
                                    <div class="nft__item_wrap">
                                        <p>Upload file to preview your banner of your collection</p>
                                    </div>
                                    <div class="nft__item_info">

                                        <div class="nft__item_click">
                                        </div>
                                        <div class="nft__item_price">
                                        </div>
                                        <div class="nft__item_action">
                                        </div>
                                        <div class="nft__item_like">
                                        </div>
                                    </div>

                                </div>



                            </div>
                            <div class="col-lg-7 offset-lg-1">
                                {/* <a href="create.html" class="fw-semibold" style={{ color: 'black' }}><i class="fa fa-fw" aria-hidden="true" title="Collectible"></i> Manage collectible type</a> */}
                                <h1 class="pb-30 title-mt">Create Collection</h1>
                                <form id="form-create-item" class="form-border" method="post" action="email.php">
                                    <div class="field-set">
                                        <h5>Upload file</h5>

                                        <div class="d-create-file">
                                            <p id="file_name">PNG, JPG, GIF, WEBP. Max 100mb.</p>
                                            <input type="button" id="get_file" class="btn-main" value="Browse" />
                                            <input type="file" id="upload_file" />
                                        </div>


                                        <div class="spacer-40"></div>

                                        <h5>Name</h5>
                                        <input type="text" name="item_title" id="item_title" class="form-control" placeholder="e.g. 'Crypto Funk" />

                                        <div class="spacer-20"></div>

                                        <h5>Description <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional)</span></h5>
                                        <textarea data-autoresize name="item_desc" id="item_desc" class="form-control" placeholder="e.g. 'Describe what the idea is, how the NFT was created, or why people should buy it.'"></textarea>

                                        <div class="spacer-20"></div>

                                        <input type="button" id="submit" class="btn-main" value="Create Collection" />

                                    </div>
                                </form>
                            </div>


                        </div>
                    </div>
                </section>

            </div>

            {/* Footer component */}
            <Footer />

        </div>
    );
}

export default CreateCollection;